// General & Report by unit
export const all = 'All'
export const save = 'CLOSE'
export const overDays = 'To continue, period must be within 1 to 7 days'
export const specificUnits = 'Search for units'
export const specificValue = 'Search for value'
export const search = 'Search'
export const unitReport = 'Diesel Report by Unit'
export const driverReport = 'Diesel Report by Driver'
export const mPGAvg = 'MPG (Avg)'
export const mPGCur = 'MPG (Last day)'
export const change = 'Change'
export const fuelOne = 'Fuel Tank 1'
export const fuelTwo = 'Fuel Tank 2'
export const lastUpdated = 'Last Updated'
export const refresh = 'Refresh'
export const refreshLabel = 'Refresh'
export const driver = 'Driver'
export const utilization = 'Utilization Score'
export const viewDrivers = 'Parkings'
export const viewUnits = 'View Units'
export const parkingsReport = 'Diesel report by Unit'
export const typeUnit = 'Search for unit...'
export const unitName = 'Name'
export const startDate = 'Start Date:'
export const endDate = 'End Date:'
export const unit = 'Unit'
export const totalMiles = 'Total Miles (mi)'
export const dieselPerformance = 'Diesel Performance (mi/gal)'
export const hoursOff = 'Hours Off (hrs)'
export const fuelTank= 'Fuel Tank %'
export const fuelConsumedParked = 'Fuel Consumed Parked (gal)'
export const parkedTime = 'Parked Time (hrs)'
export const totalDieselConsumed = 'Total Diesel Consumed (gal)'
export const updatedAt = 'Updated At'
export const RAM = 'MX'
export const ZARO = 'USA'
export const dialogAtentTitle = 'Atention'

// Active Trip
export const activeTripsReport = 'Diesel Report - Active Trips'
export const activeTrips = 'Active trips'
export const idTrip = 'Trip ID'
export const truck = 'Truck'
export const driverName = 'Driver'
export const trailerName = 'Trailer'
export const reference = 'Reference'
export const distance = 'Distance(mi)'
export const lastWeekDieselPerformance = 'Lst. Week. Perform.'
export const gal = 'Diesel(gal)'

// Geofences
export const titleCreateGeofence = 'Create geofence'
export const titleIndexGeofence = 'Geofences'
export const viewMoreGeofence = 'View map / edit'
export const deleteGeofenceBtn = 'Delete'
export const pointGeoLabel = 'Point #'
export const coordinates = 'Coordinates'
export const dialogDeleteGeoTitle = 'Do you want to eliminate the geofence with the following data?'
export const deleteGeofBtn = 'Remove'
export const backGeofBtn = 'No, go back'
export const titleEditGeofence = 'Edit geofence'
export const geofenceDeletedChip = 'Deleted'
export const seeGeofAndTrucks = 'See geofs & trucks'
export const geofencesAndTrucksTitle = 'Trucks and geofences map'
export const mapNight = "Dark"
export const mapBasic = 'Classic'
export const mapSatellite = 'Satellite'
export const mapRefreshTruckLocations = 'Refresh truck locations'
export const showOnlyUnitsInGeofences = 'Show units in geofence(s) only'

export const lblFilterByType = "Filter by type (By default shows all)"
export const lblFilterByErased = "Filter actives/deleted (By default shows all)"

export const titleGeoReactivate = "Do you want to activate the geo-fence and save your changes?"
export const optGeoReCancel = "Cancel"
export const optGeoReActivateAndSave = "Activate and save changes"
export const optGeoReJustSave = "No, just update data"

export const pagItemsPerPage = "Items per page"

// Geofences API notifications
export const ntGeoTitleSaved = 'Geofence Saved'
export const ntGeoMeSaved = 'Now you can see it here...'

export const ntGeoTitleDupl = 'Duplicated Name'
export const ntGeoMeDupl = 'Please write a different name to continue'

export const ntGeoTitleInvPoints = 'Invalid Geopoints'
export const ntGeoMeInvPoints = 'Please draw a geofence with valid points'

export const ntGeoTitleError = 'Geofence not saved'
export const ntGeoMeError = "There's an error, please verify your connection"

export const ntGeoTitleDeleted = 'Geofence deleted'
export const ntGeoTitleDelError = 'Geofence not deleted, verify your connection...'

// Geofences table headers
export const thGeoName = 'Name'
export const thGeoType = 'Type'
export const thGeoCreatedAt = 'Created at'
export const thGeoUpdatedAt = 'Updated at'
export const thGeoOptions = 'Options'

// Sidebar
export const sbByUnitSec = 'Rep.By Unit Report'
export const sbActiveTripsSec = 'Rep.By Active Trips'
export const sbGeofencesSec = 'Geofences'

export const sbHome = 'Home'
export const sbConfiguration = 'Configuration'
export const sbFinalizedTrips = 'Finalized Trips'
export const sbMailingList = 'Mailing List'
export const sbCloseSession = 'Close Session'

// Units list of geofence component
export const unListTitle = 'Units in'
export const unListNoUnitsInGeo = "There is not units in"
export const unListItemUnitName = 'Truck:'
export const unListItemAddress = 'Address:'
export const unListItemLastUpdate = 'Last update:'

// Geofence list component
export const geoListTitle = 'Geofences on map'
export const geoListItemName = 'Name:'
export const geoLitsItemType = 'Type:'

// Geofence Map Component
export const saveGeofence = 'Save Geofence'
export const activateOrSaveGeofence = 'Activate / Save Geofence'
export const goToGeofencesIndex = 'Back'
export const singleSearchMap = 'Search an adress or place...'
export const geofenceNotSelected = "Incomplete data"
export const geofenceNotSelMsg = "Please, to continue, draw a geo-fence and write a name, then you can press the save button"
export const geofenceNotSelConfirm = 'Ok, Perfect'

// Truck depreciation component
export const truckDepreciation = "Unit depreciation";
export const exit = "Exit";
export const selectFilePLaceholder = "Select file";
export const calculateNowLbl = "Calculate now";
export const depreciationCountTime = "Depreciation countable time";

// Login component
export const lgWelcome = 'Welcome'
export const lgUser = 'Username'
export const lgPass = 'Password'
export const lgLogin = 'Login'
export const lgUserRequired = 'Enter your username to continue'
export const lgPassRequired = 'Enter your password to continue'
export const lgAuthFailTitle = 'Something is wrong...'
export const lgAuthFailMsg = 'Check your credentials and internet connection'
export const lgAuthSuccessTitle = 'Hey!'
export const lgAuthSuccessMsg = 'It\'s a pleasure to have you back'
export const lgAuthCloseTitle = 'Bye'
export const lgAuthCloseMsg = 'We wait for you soon'

// Dashboard component
export const dashWelcome = 'Welcome'
export const dashFinalizedTrips = 'Finalized trips'
export const dashBranches = 'Branches'
export const dashSelectAll = 'Select all'
export const dashUnselectAll = 'Unselect all'
export const dashMore = 'more'

// Details page
export const dtlsTitle = 'Trip'
export const dtlsTruckData = 'Truck information'
export const dtlsTrailerData = 'Trailer information'
export const dtlsTruck = 'Truck'
export const dtlsTrailer = 'Trailer'
export const dtlsLatitude = 'Latitude'
export const dtlsLongitude = 'Longitude'
export const dtlsAddress = 'Address'
export const dtlsLastUpdate = 'Last update'
export const dtlsRoute = 'Route'
export const dtlsNoData = 'No data available'

export const stsTitle = 'Delivery status'
export const stsConfirmed = 'Confirmed'
export const stsOriginArrived = 'Arrived at origin'
export const stsOriginLoaded = 'Loading at origin'
export const stsDestinyArrived = 'Arrived at destination'
export const stsDestinyDownloading ='Unloading at destination'
export const stsFinalizedTrip = 'Trip completed'
export const stsAt = 'at'

// Dashboard table headers
export const hDetails = 'Details'
export const hProgress = 'Progress'
export const hPlannedDelivery = 'Planned Delivery'
export const hTopArrowDetails = 'Press the top arrow to see trip details'
export const hOpenSealChanges = 'Open changes'
export const hByTime = 'Log by time'
export const hRoute = 'Open route'
export const hSeeActivity = 'Open log'
export const hSeeDetails = 'See details'
export const hEstimated = 'Estimated'
export const hLoadingItems = 'Loading info, please wait...'
export const hSearch = 'Search'
export const hReference = 'Reference'
export const hTrip = 'Trip'
export const hShipFrom = 'Ship from'
export const hShipTo = 'Ship to'
export const hTruck = 'Truck'
export const hTrailer = 'Trailer'
export const hDriver = 'Driver'
export const hDriverActivity = 'Driver activity'
export const hTime = 'Time'
export const hSealChanges = 'Seal changes'
export const hProofDelivery = 'Proof of delivery'
export const hInvoice = 'Invoice'
export const hRowsPerPage = 'Rows per page'

// File not found component
export const fnfMessage = 'The file you are looking for is not here'
export const fnfOkBtn = 'Agree'

// Seal changes component
export const schsTitle = 'Seal changes'
export const schsTrip = 'Trip'
export const schsSeal = 'Seal'
export const schsDriver = 'Driver'
export const schsCreatedAt = 'Created at'
export const schsActions = 'Actions'
export const schsSeeSealImage = 'See seal image'

// Working on page
export const workingOnTitle = 'Page under construction, let\'s go back ...'

// Notifications settings
export const notSetTitle = 'Notification settings'
export const notSetTrip = 'Trip'
export const notSetLada = 'Lada'
export const notSetDefaultNumbers = 'Default phones'
export const notSetTripNumbers = 'Trip phones'
export const notSetPhone = 'Phone'
export const notSetClose = 'Close'
export const notSetSave = 'Save'
export const notSetGeneral = 'General'
export const notSetNotifications = 'Notifications'
export const notSetNotificationsMsg = 'We will keep you updated on the status of your trips through WhatsApp'
export const notSetNotificationsTelMsg = 'Write the phones where you will receive notifications of all your trips'
export const notSetSavedTitle = 'Ready'
export const notSetSavedMsg = 'Changes saved'
export const notSetWrongPhoneMsg = 'The following numbers contain errors:'
export const notSetAddBefore = 'Please add a phone number before continue'
export const notSetAdd = 'Add'

// 404 Page
export const nfTitle = "...Ooops! 404 Page not found"
export const nfGoHome = "Go to homepage"
export const timeDepreciationContable = 'Accounting depreciation time'
export const taxDepreciationContable = 'Tax depreciation time'
export const columnCostAcquisition = 'Acquisition amount column'
export const columnDateAcquisition = 'Acquisition date column'
export const dateDepreciation = 'Depreciation date'
export const fileData = 'File data'

